// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1oNew","productName":"Table_productName__L7GLO"};